export const widgetDefaults = {
  pageName: 'booking_my_bookings_widget',
  widget_מame: 'members_area',
};

export const settingsDefaults = {
  referralInfo: 'members_area',
};
